/**
 * FAQ Section - Landing Page
 */

import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Card } from '../../../../design-system';

const FAQ = ({ language }) => {
  const isArabic = language === 'ar';
  const [activeIndex, setActiveIndex] = useState(0);

  const faqs = isArabic
    ? [
        {
          question: 'ما هو OTP؟',
          answer: 'OTP هو كود التحقق لمرة واحدة يتم إرساله للتحقق من الهوية والأمان',
        },
        {
          question: 'هل الخدمة آمنة؟',
          answer: 'نعم، نستخدم تشفير من الدرجة الأولى وتوافق مع معايير الأمان الدولية',
        },
        {
          question: 'كم تكلفة الخدمة؟',
          answer: 'لدينا خطط مرنة تبدأ من 99 دولار شهرياً للمشاريع الصغيرة',
        },
        {
          question: 'هل تدعمون الدول العربية؟',
          answer: 'نعم، ندعم جميع الدول العربية والدول العالمية',
        },
      ]
    : [
        {
          question: 'What is OTP?',
          answer: 'OTP is a One-Time Password sent for identity verification and security',
        },
        {
          question: 'Is the service secure?',
          answer: 'Yes, we use enterprise-grade encryption and international compliance',
        },
        {
          question: 'How much does it cost?',
          answer: 'We offer flexible plans starting from $99/month for small projects',
        },
        {
          question: 'Do you support Arab countries?',
          answer: 'Yes, we support all Arab countries and international markets',
        },
      ];

  return (
    <section id="faq" className="w-full py-16 sm:py-24 md:py-32 lg:py-48 px-3 sm:px-4 bg-[#0B0E14] relative">
      {/* Background accent */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#128C7E]/5 to-transparent pointer-events-none" />
      
      <div className="relative max-w-4xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white text-center mb-4 sm:mb-6">
            {isArabic ? 'الأسئلة الشائعة' : 'Frequently Asked Questions'}
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-[#A0AEC0] leading-relaxed">
            {isArabic ? 'إجابات على أسئلتك الشائعة' : 'Answers to your common questions'}
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4">
          {faqs.map((faq, index) => (
            <Card
              key={index}
              glass
              hoverable
              className="p-4 sm:p-6 md:p-8 cursor-pointer border-l-4 border-l-transparent hover:border-l-[#128C7E] transition-all"
              onClick={() => setActiveIndex(activeIndex === index ? -1 : index)}
            >
              <div className="flex items-center justify-between gap-3 sm:gap-4">
                <h3 className="text-base sm:text-lg font-semibold text-white leading-relaxed">
                  {faq.question}
                </h3>
                <ChevronDown
                  className={`w-5 h-5 sm:w-6 sm:h-6 text-[#128C7E] transition-transform duration-300 flex-shrink-0 ${
                    activeIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </div>
              {activeIndex === index && (
                <p className="text-[#A0AEC0] mt-4 sm:mt-6 pt-4 sm:pt-6 border-t border-[#2D3748] leading-relaxed text-sm sm:text-base">{faq.answer}</p>
              )}
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
